export const optionLimit = 100; // max amount of options
export const compactCutOff = 1; // number of visible values in the trigger until it's cut off with a number
export const delimiter = new RegExp('\\r?\\n|[,|]'); // regexp to split a delimiter string by "|", "\r\n", "\n", and ",".
